import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { activeDepartmentsWithFacilityNames } from "reduxSlices/facilitiesSlice"
import { activityHubUsers } from "reduxSlices/organizationUsersSlice"
import { groups as groupsSelector } from "reduxSlices/groupsSlice"
import GroupAndUserAndDepartmentSelect from "./GroupAndUserAndDepartmentSelect"

const unselectedList = (list, selectedList) => {
  const selectedIds = selectedList.map((entry) => entry.grantee?.id || entry.id)
  return list?.filter((item) => !selectedIds.includes(item.id)) ?? []
}

const GroupAndUserAndDepartmentSearch = ({
  className = "",
  onSearchSelected,
  selectedGroups = [],
  selectedUsers = [],
  selectedDepartments = [],
}) => {
  const groups = useSelector(groupsSelector, isEqual)
  const users = useSelector(activityHubUsers, isEqual)
  const departments = useSelector(activeDepartmentsWithFacilityNames, isEqual)

  const unselectedGroups = unselectedList(groups, selectedGroups)
  const unselectedUsers = unselectedList(users, selectedUsers)
  const unselectedDepartments = unselectedList(departments, selectedDepartments)

  return (
    <GroupAndUserAndDepartmentSelect
      className={clsx(className, "text-left")}
      users={unselectedUsers}
      groups={unselectedGroups}
      departments={unselectedDepartments}
      onChange={onSearchSelected}
    />
  )
}

GroupAndUserAndDepartmentSearch.propTypes = {
  className: types.string,
  onSearchSelected: types.func.isRequired,
  selectedGroups: types.arrayOf(types.object),
  selectedUsers: types.arrayOf(types.object),
  selectedDepartments: types.arrayOf(types.object),
}

export default GroupAndUserAndDepartmentSearch
